import React, { useState, useEffect } from "react";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import axios from "axios";

const Image = (props) => {
  //========================================================================
  // Zustandsvariablen definieren
  const [imageSrc, setImageSrc] = useState(null);
  const [error, setError] = useState(false);

  //========================================================================
  // Logik
  useEffect(() => {
    // anzeigen von Bild
    let isCancelled = false;
    let objectUrl = null;

    const fetchImage = async () => {
      try {
        // IP-Adresse des Servers
        const url =
          window.location.port === "3000"
            ? `http://${window.location.hostname}:${globalVars.httpPort}/project/images/${props.element.imgSrc}`
            : `/project/images/${props.element.imgSrc}`;
        const response = await axios.get(url, {
          responseType: "blob",
        });

        if (!isCancelled) {
          objectUrl = URL.createObjectURL(response.data);
          setImageSrc(objectUrl);
        } else {
          URL.revokeObjectURL(URL.createObjectURL(response.data));
        }
      } catch (error) {
        if (!isCancelled) {
          setError(true);
        }
      }
    };

    fetchImage();

    return () => {
      isCancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [props.element.imgSrc, globalVars.updateElementsTrigger]);

  //========================================================================
  // Grafische Darstellung
  if (error) {
    return (
      <p>
        {language.displayText(["Bild konnte nicht geladen werden", "", ""])}
      </p>
    );
  }

  return (
    <img
      style={{
        ...props.style,
        visibility: props.props.visibility,
      }}
      src={imageSrc}
      // alt={props.element.imgSrc}
      title={
        globalVars.cyclicUpdate || globalVars.editor
          ? "\n" + ("Bild: " + props.element.imgSrc)
          : ""
      }
    />
  );
};

export default Image;
